var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg86(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.125C6.20304 3.125 3.125 6.20304 3.125 10C3.125 13.797 6.20304 16.875 10 16.875C13.797 16.875 16.875 13.797 16.875 10C16.875 6.20304 13.797 3.125 10 3.125ZM1.875 10C1.875 5.51269 5.51269 1.875 10 1.875C14.4873 1.875 18.125 5.51269 18.125 10C18.125 14.4873 14.4873 18.125 10 18.125C5.51269 18.125 1.875 14.4873 1.875 10ZM9.375 6.875C9.375 6.52982 9.65482 6.25 10 6.25H10.0062C10.3514 6.25 10.6312 6.52982 10.6312 6.875V6.88125C10.6312 7.22643 10.3514 7.50625 10.0062 7.50625H10C9.65482 7.50625 9.375 7.22643 9.375 6.88125V6.875ZM9.13007 8.7987C10.0853 8.3211 11.1608 9.18384 10.9018 10.2199L10.3109 12.5833L10.3455 12.566C10.6542 12.4116 11.0296 12.5367 11.184 12.8455C11.3384 13.1542 11.2133 13.5296 10.9045 13.684L10.8699 13.7013C9.91475 14.1789 8.83923 13.3162 9.09824 12.2801L9.68908 9.91673L9.65451 9.93402C9.34577 10.0884 8.97035 9.96325 8.81598 9.65451C8.66161 9.34577 8.78675 8.97035 9.09549 8.81598L9.13007 8.7987Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg86);
export default __webpack_public_path__ + "static/media/svg86.a67f9783c9982e80cdc8f613f7983278.svg";
export { ForwardRef as ReactComponent };